import React, { useState, useEffect } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';

import './styles.css';

const CheckoutForm = ({ clientSecret, selectedPlan, closePaymentDialog }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [selected, setSelected] = useState('email');
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [isCheckedTerm1, setIsCheckedTerm1] = useState(false);
  const [isCheckedTerm2, setIsCheckedTerm2] = useState(false);
  const [isCardValid, setIsCardValid] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const handleChangeEmail = (event) => {
    const value = event.target.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsValidEmail(emailRegex.test(value));
  };

  const handleChangeTerm1 = () => {
    setIsCheckedTerm1((prev) => !prev);
  };

  const handleChangeTerm2 = () => {
    setIsCheckedTerm2((prev) => !prev);
  };

  const handleCardChange = (event) => {
    setIsCardValid(event.complete);
  };

  useEffect(() => {
    if (isValidEmail && isCheckedTerm1 && isCheckedTerm2 && isCardValid) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [isValidEmail, isCheckedTerm1, isCheckedTerm2, isCardValid]);

  const handleCheckboxChange = (id) => {
    setSelected((prev) => (prev === id ? null : id));
  };

  let plan;
  let price;

  if (selectedPlan === 'price_id_yearly_basic') {
    plan = 'Basic Yearly';
    price = '12.99';
  }
  if (selectedPlan === 'price_id_monthly_basic') {
    plan = 'Basic Monthly';
    price = '1.99';
  }
  if (selectedPlan === 'price_id_yearly_premium') {
    plan = 'Premium Yearly';
    price = '49.99';
  }
  if (selectedPlan === 'price_id_yearly_basic') {
    plan = 'Premium Monthly';
    price = '6.99';
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      console.error('Stripe não está carregado.');
      return;
    }

    const cardElement = elements.getElement(CardElement);

    const { error, paymentIntent } = await stripe.confirmCardPayment(
      clientSecret,
      {
        payment_method: {
          card: cardElement,
        },
      }
    );

    if (error) {
      console.error('Erro ao confirmar o pagamento:', error.message);
      alert(`Error: ${error.message}`);
    } else if (paymentIntent) {
      console.log('Pagamento confirmado:', paymentIntent);
      alert('Pagamento realizado com sucesso!');
    }
  };

  const cardStyle = {
    style: {
      base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '16px',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
      },
    },
  };

  return (
    <form onSubmit={handleSubmit} className="checkout-form z-50">
      <button
        onClick={closePaymentDialog}
        type="button"
        className=" rounded-md p-2 inline-flex items-center justify-center
         text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none
          focus:ring-2 focus:ring-inset focus:ring-indigo-500"
      >
        <span className="sr-only">Close menu</span>
        <svg
          className="h-6 w-6"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
      <div className="flex w-full flex-col align-middle justify-start mt-10 border-b-slate-800 border-b-[1px] border-solid pb-10 mb-10">
        <p className="text-center text-4xl">{plan}</p>
        <div className="text-center text-2xl">€{price}</div>
      </div>
      <label
        htmlFor="input-group-1"
        className="block mb-2 text-sm font-medium text-gray-900"
      >
        Your Email Address*
      </label>
      <div className="relative mb-6">
        <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none focus:outline-0">
          <svg
            className="w-4 h-4 text-gray-500 dark:text-gray-400"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 20 16"
          >
            <path d="m10.036 8.278 9.258-7.79A1.979 1.979 0 0 0 18 0H2A1.987 1.987 0 0 0 .641.541l9.395 7.737Z" />
            <path d="M11.241 9.817c-.36.275-.801.425-1.255.427-.428 0-.845-.138-1.187-.395L0 2.6V14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2.5l-8.759 7.317Z" />
          </svg>
        </div>
        <input
          type="email"
          id="input-group-1"
          onChange={handleChangeEmail}
          className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full ps-10 p-2.5 ${
            isValidEmail ? 'border-green-500' : 'border-red-500'
          }`}
          placeholder="example@email.com"
        />
      </div>

      <div className="mb-5">
        <div className="block mb-2 text-sm font-medium text-gray-900">
          How do you want to activate the plan?*
        </div>
        <div>
          <input
            className="w-4 h-4 mr-2"
            type="checkbox"
            checked={selected === 'email'}
            onChange={() => handleCheckboxChange('email')}
          />
          <span>Active on my Email</span>
        </div>
        <div>
          <input
            className="w-4 h-4 mr-2"
            type="checkbox"
            checked={selected === 'random'}
            onChange={() => handleCheckboxChange('random')}
          />
          <span>Generate a Random Code</span>
        </div>
      </div>
      <CardElement
        options={cardStyle}
        className="card-element"
        onChange={handleCardChange}
      />
      <div className="mb-7">
        <div className="align-middle flex">
          <input
            className="mr-2"
            type="checkbox"
            name=""
            id=""
            checked={isCheckedTerm1}
            onChange={handleChangeTerm1}
          />
          <span className="text-xs">
            I agree with the{' '}
            <a
              className="text-blue-600 dark:text-blue-500 hover:underline"
              href="/"
            >
              Terms and Conditions
            </a>{' '}
            &{' '}
            <a
              className="text-blue-600 dark:text-blue-500 hover:underline"
              href="/"
            >
              Privacy Policy
            </a>
            *
          </span>
        </div>
        <div className="align-middle flex mt-2">
          <input
            className="mr-2"
            type="checkbox"
            name=""
            id=""
            checked={isCheckedTerm2}
            onChange={handleChangeTerm2}
          />
          <span className="text-xs">
            I agree with the{' '}
            <a
              className="text-blue-600 dark:text-blue-500 hover:underline"
              href="/"
            >
              Refund Policy.
            </a>
            *
          </span>
        </div>
      </div>
      <button type="submit" disabled={buttonDisabled} className="submit-button">
        Confirm Payment
      </button>
    </form>
  );
};

export default CheckoutForm;
